import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import style from './style.module.scss';

const UserModalSkeleton = () => {
  return (
    <>
      <div className={style.modalBodyUser}>
        <div className={style.skeletonUserInfoWrapper}>
          <div className={style.skeletonUserInfoImageWrapper}>
            <SkeletonBlock className={style.skeletonUserInfoImage} />
          </div>
          <div className={style.skeletonUserInfo}>
            <div className={style.skeletonUserInfoNameWrapper}>
              <SkeletonBlock className={style.skeletonUserInfoName} />
              <SkeletonBlock className={style.skeletonUserStatusBlock} />
            </div>
            <SkeletonBlock className={style.skeletonUserStatusBlock} />
          </div>
        </div>
      </div>
      <div className={style.skeletonFieldsWrapper}>
        {[...Array(9)].map((_) => (
          <SkeletonBlock key={uuidv4()} className={style.skeletonField} />
        ))}
      </div>
    </>
  );
};

export default UserModalSkeleton;
